import axios from 'axios'

const SETTINGS = {
  siteHomeUrl: 'http://127.0.0.1:8080',
  apiUrl: 'http://127.0.0.1:8000',
  nonce: undefined,
  // This is 100% for testing purposes only.
  //    (may need to create a test_user first)
  // authToken: 'paste contents from `$ python manage.py drf_create_token <test_user>`'
  authToken: 'a1792ffa6b1a3c0c522b308af8f8a3e08e5022e7'
}

function setApiData(siteHomeUrl, apiUrl, nonce) {
  SETTINGS.siteHomeUrl = siteHomeUrl
  SETTINGS.apiUrl = apiUrl
  SETTINGS.nonce = nonce

  console.log(SETTINGS)
}

function prepareConfig(params = undefined) {
  var config = {}
  var headers = {}

  if (SETTINGS.nonce) {
    headers['X-WP-Nonce'] = SETTINGS.nonce
  } else {
    headers['Authorization'] = `Token ${SETTINGS.authToken}`
  }

  config['headers'] = headers
  if (params) {
    config['params'] = params
  }

  return config
}

function makeGetRequest(apiView, params) {
  return axios.get(`${SETTINGS.apiUrl}/${apiView}`, prepareConfig(params))
}

function makePostRequest(apiView, data) {
  return axios.post(`${SETTINGS.apiUrl}/${apiView}`, data, prepareConfig())
}

function makePutRequest(apiView, data) {
  return axios.put(`${SETTINGS.apiUrl}/${apiView}`, data, prepareConfig())
}

function makeDeleteRequest(apiView) {
  return axios.delete(`${SETTINGS.apiUrl}/${apiView}`, prepareConfig())
}

function getProgram() {
  return makeGetRequest('api/program/')
}

function getBuilding() {
  return makeGetRequest('api/building/')
}

function getStudent(date) {
  return makeGetRequest(`api/student/`, {
    date: date
  })
}

function getStudentData(date, internal_id) {
  return makeGetRequest(`api/student_data/`, {
    date: date,
    internal_id: internal_id
  })
}

function getStudentDetail(data) {
  return makeGetRequest(`api/student_data_detail/id/${data}/`)
}

function getBus() {
  return makeGetRequest(`api/bus/`)
}

function getRoute() {
  return makeGetRequest(`api/route/`)
}

function getEvent(basedOn, data) {
  return makeGetRequest(`api/calendar_event/${basedOn}/${data}/`)
}

function getUser() {
  return makeGetRequest(`api/user/`)
}

function postNewStudentForm(data) {
  return makePostRequest(`api/new_request_form/`, data)
}

function putChangeStudentForm(data, internalId) {
  return makePutRequest(`api/new_request_form/${internalId}/`, data)
}

function postNewOneTimeNoRideForm(data) {
  return makePostRequest(`api/one_time_no_ride_form/`, data)
}

function postNewDailyNoShowForm(data) {
  return makePostRequest(`api/daily_no_show_form/`, data)
}

function postNewCalendarEvent(data) {
  return makePostRequest(`api/calendar_event/`, data)
}

function postNewCancelForm(data, internalId) {
  return makePostRequest(`api/schedule_cancel_form/${internalId}/`, data)
}

function deleteCalendarEvent(basedOn, data) {
  return makeDeleteRequest(`api/calendar_event/${basedOn}/${data}/`)
}

export {
  setApiData,
  getProgram,
  getBuilding,
  getStudent,
  getStudentData,
  getStudentDetail,
  getBus,
  getRoute,
  getEvent,
  getUser,
  postNewStudentForm,
  putChangeStudentForm,
  postNewOneTimeNoRideForm,
  postNewDailyNoShowForm,
  postNewCalendarEvent,
  postNewCancelForm,
  deleteCalendarEvent
}
